import {
  // eslint-disable-next-line no-restricted-imports
  showToast as beyondShowToast,
  ShowToast,
} from '@zeiss/beyond-online-react';

/* Ensure to disable auto dismiss for error toasts */
export const showToast: ShowToast = (args) => {
  const { props, timeout } = args;
  const { type } = props;

  return beyondShowToast({
    props,
    timeout: type === 'error' ? false : timeout,
  });
};
